const publicPath = process.env.BASE_URL;
const pathToImg = "assets/img/";
const chartType = {
  table: "table.png",
  area: "areaChart.png",
  bar: "barChart.png",
  bubble: "bubbleChart.png",
  column: "columnChart.png",
  doughnut: "doughnutChart.png",
  gauges: "gaugesChart.png",
  line: "lineChart.png",
  pie: "pieChart.png",
  radar: "radarChart.png",
  scatter: "scatterChart.png"
};

/**
 * If you want to add a new widget, you need to push it here and then import a component for this widget
 * to Landing.vue component which is in src/components/auth folder.
 */
export const sidebarWidgets = [
  {
    avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
    componentName: "Group List",
    componentType: "middle",
    componentDescription:
      "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?",
    component: "GroupList",
    componentImg: `${publicPath}${pathToImg}${chartType.table}`
  },
  {
    avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
    componentName: "Group Chart",
    componentType: "middle",
    componentDescription: "Groups",
    component: "GroupChart",
    componentImg: `${publicPath}${pathToImg}${chartType.column}`
  },
  {
    avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
    componentName: "Club Records",
    componentType: "large",
    componentDescription:
      "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
    component: "Records",
    componentImg: `${publicPath}${pathToImg}${chartType.table}`
  },
  {
    avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
    componentName: "Athlete List",
    componentType: "middle",
    componentDescription:
      "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
    component: "AthleteList",
    componentImg: `${publicPath}${pathToImg}${chartType.table}`
  },
  {
    avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
    componentName: "Athlete Ranks Results",
    componentType: "large",
    componentDescription:
      "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
    component: "AthleteRanksResults",
    componentImg: `${publicPath}${pathToImg}${chartType.table}`
  },
  {
    avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
    componentName: "Athlete Attendance",
    componentType: "middle",
    componentDescription:
      "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
    component: "AthleteAttendance",
    componentImg: `${publicPath}${pathToImg}${chartType.table}`
  },
  {
    avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
    componentName: "Upload Files",
    componentType: "large",
    componentDescription:
      "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
    component: "UploadFiles",
    componentImg: `${publicPath}${pathToImg}${chartType.table}`
  }
];
